import { render } from "./SvgTrailerShell.vue?vue&type=template&id=66c5553a&ts=true"
import script from "./SvgTrailerShell.vue?vue&type=script&lang=ts"
export * from "./SvgTrailerShell.vue?vue&type=script&lang=ts"

import "./SvgTrailerShell.vue?vue&type=style&index=0&id=66c5553a&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__